import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    auth: false,
    token: '',
    email: '',
    admin: false,
  },
  mutations: {
    setAuth(state) {
      state.auth = true;
    },
    setNotAuth(state) {
      state.auth = false;
    },
    setAdmin(state) {
      state.admin = true;
    },
    setNotAdmin(state) {
      state.admin = false;
    },
    setToken(state, token: string) {
      state.token = token;
    },
    setEmail(state, email: string) {
      state.email = email;
    },
  },
  // actions: {
  // },
  getters: {
    isAuth: (state) => () => {
      return state.auth;
    },
    isAdmin: (state) => () => {
      return state.admin;
    },
    getToken: (state) => () => {
      return state.token;
    },
    getEmail: (state) => () => {
      return state.email;
    },
  },
});
